/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-camping.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel Camping',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0498 5.7972C28.214 5.49354 28.1009 5.11432 27.7972 4.95018C27.4935 4.78604 27.1143 4.89914 26.9502 5.2028L24.5 9.73564L22.0498 5.2028C21.8857 4.89914 21.5065 4.78604 21.2028 4.95018C20.8991 5.11432 20.786 5.49354 20.9502 5.7972L23.7895 11.05L7.12737 41.875H4.5C4.15482 41.875 3.875 42.1548 3.875 42.5C3.875 42.8452 4.15482 43.125 4.5 43.125H7.48721C7.49538 43.1252 7.50354 43.1252 7.5117 43.125H16.4866C16.4952 43.1252 16.5037 43.1252 16.5123 43.125H32.4877C32.4963 43.1252 32.5048 43.1252 32.5134 43.125H41.4883C41.4965 43.1252 41.5046 43.1252 41.5128 43.125H43.5C43.8452 43.125 44.125 42.8452 44.125 42.5C44.125 42.1548 43.8452 41.875 43.5 41.875H41.8726L25.2105 11.05L28.0498 5.7972ZM32.8726 41.875H40.4517L24.5 12.3644L8.5483 41.875H16.1274L23.9502 27.4028C24.0593 27.2009 24.2704 27.075 24.5 27.075C24.7296 27.075 24.9407 27.2009 25.0498 27.4028L32.8726 41.875ZM17.5483 41.875H31.4517L24.5 29.0144L17.5483 41.875Z"
            fill="#333333"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
